import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Thing, WithContext } from 'schema-dts';

interface JsonLdProps<DataType extends Thing> {
  data: WithContext<DataType>;
}

export const JsonLd = <DataType extends Thing>({ data }: JsonLdProps<DataType>): JSX.Element => {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};
